<template>
  <div class="ee-form-item2" :class="{'is-error': errMsg}">
    <div v-if="fieldValue || errMsg" class="ee-form-item2--top">
      <label v-if="fieldValue && label">{{label}}</label>
      <span class="ee-form-item2__error-msg">{{errMsg}}</span>
    </div>
    <slot></slot>
    <div class="ee-form-item2--bottom">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>
<script>
  import findNode from '../mixin/findNode'
  import { validField } from '../utils/valid'
  export default {
    compName: 'ee-form-item2',
    mixins: [findNode],
    props: {
      errorMsg: null,
      prop: String,           // 属性名
      label: String
    },
    data () {
      return {
        isRequired: false,
        errMsg: this.errorMsg || '',
        form: this.getParent('ee-form')
      }
    },
    watch: {
      errorMsg () {
        this.errMsg = this.errorMsg
      }
    },
    computed: {
      fieldValue: {
        cache: false,
        get () {
          const data = this.form.dataObject
          return data[this.prop]
        }
      }
    },
    methods: {
      validate (trigger) {
        if (this.prop) {
          const rules = this.form.rules[this.prop]
          if (rules && rules.length > 0) {
            return Promise.all(rules.map(rule => !trigger || rule.trigger === trigger ? new Promise((resolve, reject) => {
              validField(rule, this.fieldValue, err => {
                if (err) {
                  this.errMsg = err
                  reject(err)
                } else {
                  resolve()
                }
              })
            }) : Promise.resolve()))
              .then(() => (this.errMsg = ''))
          }
        }
        return Promise.resolve()
      },
      resetField () {
        this.form.dataObject[this.prop] = this.initialValue
      },
      getRules () {
        if (this.prop) {
          return this.form.rules[this.prop]
        }
      },
      handleValidBlur () {
        this.validate('blur')
      },
      handleValidChange () {
        this.validate('change')
      }
    },
    mounted () {
      if (this.prop) {
        // 若设置了prop属性 将元素注册到form里
        this.form.$emit('ee.form.addField', this)
        Object.defineProperty(this, 'initialValue', {
          value: this.fieldValue
        })
        const rules = this.getRules()
        if (rules && rules.length > 0) {
          rules.every(rule => {
            if (rule.required) {
              this.isRequired = true
              return false
            }
            return true
          })
          this.$on('ee.form.blur', this.handleValidBlur)
          this.$on('ee.form.change', this.handleValidChange)
        }
      }
    },
    beforeDestory () {
      this.form.$emit('ee.form.removeField', this)
    }
  }
</script>
<style>
@component-namespace gd {
  @b form-item2 {
    position: relative;
    padding-top: 20px;
    margin-bottom: 30px;
    @when error {
      .ee-form-item2__error-msg {
        display: inline;
      }
      input {
        border-color: #A41B1B;
      }
    }
    input {
      height: 32px;
      width: 100%;
      border: 0 none;
      border-bottom: 2px solid #eee;
      outline: none;
      background-color: transparent;
    }
    @m top {
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      color: #7C8495;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      label {
        margin-right: 10px;
      }
    }
    @m bottom {
      position: absolute;
      width: 100%;
      bottom: -30px;
    }
    @e error-msg {
      display: none;
      color: #A41B1B;
    }
  }
}
.ee-form--small {
  .ee-form-item2 {
    padding-top: 16px;
    margin-bottom: 24px;
    input {
      height: 26px;
    }
    .ee-form-item2--bottom {
      bottom: -24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/packages/form/FormItem2.vue?569ddaa5